import React from 'react'

import HeadNext from 'next/head'

import Breadcrumb from 'components/Breadcrumb'
import Grid, { Container } from 'components/Grid'
import MainLayout from 'components/Layout/Main'
import Paper from 'components/Paper'
import { formatDateString } from 'helpers/legalPage/formatDateString'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import TableOfContents from './components/TableOfContents'
import ContentfulDocument from '../legalPages/components/ContentfulDocument/ContentfulDocument'

import classes from './CategoryLeadersMethodology.module.scss'

const CategoryLeadersMethodology = ({ data, appData }) => {
  const currentPath = routeService.generatePath(ROUTE_NAMES.CATEGORY_LEADERS_METHODOLOGY)
  const breadcrumbItems = [
    {
      name: 'Category Leaders Methodology',
      path: currentPath,
    },
  ]
  const contentfulData = data.content

  return (
    <>
      <HeadNext>
        <title>{'Category Leaders Methodology | GetApp Research'}</title>
        <meta
          name="description"
          content="Category Leaders identifies leading cloud-based software products for small businesses. If you're a small business owner or decision maker evaluating technology for your company, Category Leaders is for you."
        />
        <link href={`${appData.host}${currentPath}`} rel="canonical"></link>
      </HeadNext>
      <br></br>
      <Breadcrumb structuredDataItems={breadcrumbItems}>
        {/* @ts-ignore - Breadcrumb.Item exists at runtime */}
        <Breadcrumb.Item action="go-to_resource_homepage" isDisabled>
          Category Leaders Methodology
          {/* @ts-ignore - Breadcrumb.Item exists at runtime */}
        </Breadcrumb.Item>
      </Breadcrumb>
      <Container className={classes.container}>
        <h1 className={classes.homepageHeadline}>GetApp&apos;s Category Leaders</h1>
        <Grid container spacing={3} className={classes.mainSection}>
          <Grid item xs={12} sm={3}>
            <Paper className={classes.card}>
              <TableOfContents contentfulData={contentfulData} />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Paper className={classes.card}>
              <div className={classes.content}>
                <ContentfulDocument content={contentfulData.json} links={data.content.links} />
                {data.updated && (
                  <p>
                    <br /> Page Last Updated: <b>{formatDateString(data.updated.publishedAt)}</b>
                  </p>
                )}
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

CategoryLeadersMethodology.Layout = MainLayout

export default CategoryLeadersMethodology
